import { Outlet } from "react-router-dom";
import BaggageTripForm from "./BaggageTripForm";
import BaggageTripList from "./BaggageTripList";
import BaggageTripDetail from "./BaggageTripDetail";
import BaggageTripWizard from "./BaggageTripWizard";

export const adminBaggageTripsRoutes = [
  {
    path: "baggage-trips",
    element: Outlet,
    children: [
      {
        path: "",
        element: BaggageTripList,
      },
      {
        path: "list",
        element: BaggageTripList,
      },
      {
        path: "add",
        element: BaggageTripWizard,
      },
      {
        path: "edit/:id",
        element: BaggageTripForm,
      },
      {
        path: "detail/:id",
        element: BaggageTripDetail,
      },
    ],
  },
];
